import React from "react";
import Header from "./Component/Header";
import Layout from "./Component/Courses";
import Coup from "./Component/Coupon";
import Paginate from "./Component/Paginate";
import ShareComp from "./Services/ShareComp";
import Footer from "./Component/Footer";
import SearchBar from "./Component/SearchBar";
import { BrowserRouter as Router } from "react-router-dom";
import SliderBar from "./Component/SliderBar";
import "../src/App.css";
import ResponsiveAppBar from "./Component/Header";
import VanityLinks from "./Component/VanityLinks";
import Home from "./Component/Navbar Components/Home";

function App() {
  return (
    <>
      <div className="App">
        <Header />
        <ShareComp />
        <br />
      </div>
      <Footer />
    </>
  );
}

export default App;
